// @flow

const _narrow = 'narrow'
const _medium = 'medium'
const _wide = 'wide'

export function getWidthAsText (width?: number) {
  if (!width) {
    return _narrow
  }
  if (width < 540) {
    return _narrow
  } else if (width < 720) {
    return _medium
  } else {
    return _wide
  }
}



// WEBPACK FOOTER //
// ./src/v2/components/withComparison/lib/getWidthAsText.js